import { render } from "./BaseCard.vue?vue&type=template&id=691358ca&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=691358ca&scoped=true&lang=css"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691358ca"]])

export default __exports__